import { ShopifyApi } from '../../generated/api';
import configuration from './configuration';

export const shopifyApi = new ShopifyApi(configuration);
